import EventEmitter from "eventemitter3";

const IPCKEY = "DYIPCCenter";

class IPCCenter {
  static instance = new IPCCenter();

  static getInstance() {
    return IPCCenter.instance;
  }

  private uuid: string;
  private events: EventEmitter;

  constructor() {
    this.uuid = String(new Date().getTime() + Math.random());
    this.events = new EventEmitter();

    window.onstorage = (evt) => {
      // evt.key, evt.oldValue, evt.newValue
      if (evt.key == IPCKEY) {
        this.triggerEvent(evt);
      }
    };
  }

  broadCastEvent(event: string, msg: any) {
    const broadCastObj: any = {
      msg: msg,
      event: event,
      uuid: this.uuid,
      timestamp: new Date().getTime(),
    };
    localStorage.setItem(IPCKEY, JSON.stringify(broadCastObj));

    broadCastObj.isMyself = true;
    this.events.emit(event, broadCastObj);
  }

  private triggerEvent(evt: any) {
    try {
      const eventObj = JSON.parse(evt.newValue);
      this.events.emit(eventObj.event, eventObj);
    } catch (e) {
      console.log("IPCCenter error : ", e);
    }
  }

  addListener(event: string, callback: any) {
    this.events.on(event, callback);
  }
}

export default IPCCenter;
